import { cn } from '@savvy-kit/lib/utils';

import type { ClientPortalAllocationSlice } from './allocation';

type AllocationBarProps = {
  readonly slices: readonly ClientPortalAllocationSlice[];
  readonly className?: string;
};

export function AllocationBar({ slices, className }: AllocationBarProps) {
  return (
    <div
      aria-hidden="true"
      data-slot="allocation-bar"
      className={cn('flex h-3 w-full overflow-hidden rounded-full', className)}
    >
      {slices.map((slice) => (
        <div
          key={slice.name}
          className="h-full min-w-0"
          style={{ flexGrow: slice.percent, flexBasis: 0, backgroundColor: slice.color }}
        />
      ))}
    </div>
  );
}
